import { AnonUserCriteria } from 'modules/graphql/types/GraphQLAnonymousCriteria';
import { BADGE_VARIANTS, Badge } from 'ui/badge';

export const StatusCell = ({ criteria }: { criteria: AnonUserCriteria }) => {
  const getLabel = () => {
    if (criteria?.isArchived) return 'Archived';
    if (criteria?.fields?.isLive) return 'Live';
    return 'Off';
  };
  return (
    <Badge
      data-test={`badge-${getLabel().toLowerCase()}`}
      variant={criteria?.fields?.isLive ? BADGE_VARIANTS.RUNNING : BADGE_VARIANTS.DRAFT}
    >
      {getLabel()}
    </Badge>
  );
};
